import React from 'react'

import { GridActionsCellItem } from '@mui/x-data-grid-pro'
import { PencilAlt } from '@styled-icons/heroicons-outline/PencilAlt'
import { Trash } from '@styled-icons/heroicons-outline/Trash'
import { ERROR } from 'theme/colors'

import T from 'T'

const RenderGetActionsDataCell = ({ row, onEdit, onDelete }) => {
  return [
    <GridActionsCellItem key="edit" icon={<PencilAlt size={20} />} label={T.EDIT_CONTAINER_TYPE} showInMenu onClick={() => onEdit(row)} />,
    <GridActionsCellItem
      key="delete"
      icon={<Trash size={20} color={ERROR.main} />}
      label={T.DELETE_CONTAINER_TYPE}
      showInMenu
      onClick={() => onDelete(row)}
      sx={{ color: 'error.main' }}
    />,
  ]
}

export default RenderGetActionsDataCell
